module.exports = __webpack_public_path__ + "static/media/bousolle_darkbleu.7b61921e.svg";